import React, { useState, useEffect } from "react";
import styles from "./Hero.module.css";
import { Link, useLocation } from "react-router-dom";

export default function Hero() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleAnchorClick = (e) => {
      const target = e.target.closest('a[href^="/#"]');
      if (target && isMenuOpen) {
        closeMenu();
      }
    };

    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, [isMenuOpen]);

  const location = useLocation();
  useEffect(() => {
    // Jeśli w URL jest hash (np. /#gallery, /#contact)
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth"
        });
      }
    } else {
      // Jeśli nie ma hasha (np. po prostu /), przewiń na samą górę
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [location]); // uruchamia się za każdym razem, gdy zmienia się URL
  return (
    <section id="hero" className={`sectionContainer ${styles.backImage}`}>
      <div className={styles.sectionTitle}>
        <h1 className={styles.title}>
          {" "}
          Tworzymy nowoczesne strony internetowe i prowadzimy szkolenia
          informatyczne
        </h1>
      </div>
      <div className={styles.heroContent}>
        <img
          src={`${process.env.PUBLIC_URL}/Images/Logo/LogoArtKoz.webp`}
          alt="Logo ArtKoz"
          className={styles.heroImage}
        />
        <div className={styles.heroCards}>
          <Link to="/web" onClick={closeMenu} className={styles.heroCard}>
            <h3>Strony internetowe</h3>
            <p>
              Projektujemy i kodujemy nowoczesne strony WWW od podstaw – bez
              gotowych szablonów.
            </p>

            <div className={styles.go}>
              <div>
                <span>
                  {" "}
                  <span>Poznaj ofertę stron WWW</span>
                </span>
              </div>
              <div>
                <i className={`${styles.iconHero} fa fa-globe`} />
              </div>
            </div>
          </Link>

          <Link to="/training" onClick={closeMenu} className={styles.heroCard}>
            <h3> Szkolenia informatyczne</h3>
            <p>
              Prowadzimy szkolenia dla osób prywatnych, firm oraz osób 50+,
              dopasowane do poziomu uczestników.
            </p>
            <div className={styles.go}>
              <div>
                <span> Zobacz szkolenia</span>
              </div>
              <div>
                <i className={`${styles.iconHero} fa fa-globe`} />
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
